module.exports = __webpack_public_path__ + "static/media/bmcc_logo.7ab386dc.png";